"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionRoot = exports.SelectorItem = exports.SelectorRoot = exports.Dashboard = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
/**
 * @deprecated
 */
var Dashboard = function (props) {
    return (react_1.default.createElement(DashboardPane, null,
        react_1.default.createElement(HeaderPane, null,
            react_1.default.createElement(SelectorPane, null, props.selector),
            react_1.default.createElement(ActionPane, null, props.action)),
        react_1.default.createElement(BodyPane, null, props.children)));
};
exports.Dashboard = Dashboard;
var DashboardPane = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  height: 100%;\n\n  margin: 0 30px;\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  height: 100%;\n\n  margin: 0 30px;\n"])));
var HeaderPane = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex: 0 0 60px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex: 0 0 60px;\n"])));
var SelectorPane = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var ActionPane = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var BodyPane = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  height: calc(100% - 60px);\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  height: calc(100% - 60px);\n"
    /**
     * @deprecated
     */
])));
/**
 * @deprecated
 */
exports.SelectorRoot = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 24px 0 15px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direciton: row;\n"], ["\n  padding: 24px 0 15px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direciton: row;\n"
    /**
     * @deprecated
     */
])));
/**
 * @deprecated
 */
exports.SelectorItem = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-right: 30px;\n  &:last-child {\n    margin-right: 0;\n  }\n"], ["\n  margin-right: 30px;\n  &:last-child {\n    margin-right: 0;\n  }\n"
    /**
     * @deprecated
     */
])));
/**
 * @deprecated
 */
exports.ActionRoot = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding: 14px 0 12px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direciton: row;\n\n  & > * {\n    margin-left: 20px;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"], ["\n  padding: 14px 0 12px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direciton: row;\n\n  & > * {\n    margin-left: 20px;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
